'use es6';

import tinymce from 'tinymce';
import { HS_EMOJI } from '../constants/plugins';
import { addControls } from './controls';
function emojiPlugin(editor) {
  addControls(editor);
}
tinymce.PluginManager.add(HS_EMOJI, emojiPlugin);